module.exports = __webpack_public_path__ + "img/bar-chart.32b02b9d.svg";